<template>
  <div>
        <v-toolbar flat color="white" class= "pt-3">
      <v-tabs slider-color="primary">
        <v-tab-slider color="primary"></v-tab-slider>

        <v-tab @click="tagComponentTab=true; communicationProtocolComponentTab=false; tagCategoryComponentTab=false; accessPointComponentTab =false; accessPointGroupComponentTab =false; accessTransactionLogComponentTab =false; accessDeviceComponentTab = false">Tags
        </v-tab>
        <v-tab @click="tagComponentTab=false; communicationProtocolComponentTab=true; tagCategoryComponentTab=false; accessPointComponentTab =false; accessPointGroupComponentTab =false; accessTransactionLogComponentTab =false; accessDeviceComponentTab = false">Communication Protocol       
        </v-tab>
        <v-tab @click="tagComponentTab=false; communicationProtocolComponentTab=false; tagCategoryComponentTab=true; accessPointComponentTab =false; accessPointGroupComponentTab =false; accessTransactionLogComponentTab =false; accessDeviceComponentTab = false">Tag Categories
        </v-tab>
        <v-tab @click="tagComponentTab=false; communicationProtocolComponentTab=false; tagCategoryComponentTab=false; accessPointComponentTab =true; accessPointGroupComponentTab =false; accessTransactionLogComponentTab =false; accessDeviceComponentTab = false">Access Points
        </v-tab>
        <v-tab @click="tagComponentTab=false; communicationProtocolComponentTab=false; tagCategoryComponentTab=false; accessPointComponentTab =false; accessPointGroupComponentTab =true; accessTransactionLogComponentTab =false; accessDeviceComponentTab = false">Access Point Groups
        </v-tab>
        <v-tab @click="tagComponentTab=false; communicationProtocolComponentTab=false; tagCategoryComponentTab=false; accessPointComponentTab =false; accessPointGroupComponentTab =false; accessTransactionLogComponentTab =true; accessDeviceComponentTab = false">Access Transaction Logs
        </v-tab>
         <v-tab @click="tagComponentTab=false; communicationProtocolComponentTab=false; tagCategoryComponentTab=false; accessPointComponentTab =false; accessPointGroupComponentTab =false; accessTransactionLogComponentTab =false; accessDeviceComponentTab = true">Access Devices
        </v-tab>

      </v-tabs>
    </v-toolbar>

    <tagscomponent v-if="tagComponentTab"
      :tagsinfo="tags"
      :isloading="isLoading"
    ></tagscomponent>

     <communicationprotocolscomponent v-if="communicationProtocolComponentTab"
      :communicationprotocolsinfo="communicationProtocols"
      :isloading="isLoading"
    ></communicationprotocolscomponent>

     <tagcategoriescomponent v-if="tagCategoryComponentTab"
      :tagcategoriesinfo="tagCategories"
      :isloading="isLoading"
    ></tagcategoriescomponent>

      <accesspointscomponent v-if="accessPointComponentTab"
      :isloading="isLoading"
       :accesspointinfo="accessPoints"
    ></accesspointscomponent>

    <accesspointgroupscomponent v-if="accessPointGroupComponentTab"
      :isloading="isLoading"
       :accesspointgroupsinfo="accessPointGroups"
    ></accesspointgroupscomponent>

      <accesstransactionlogscomponent v-if="accessTransactionLogComponentTab"
      :isloading="isLoading"
       :accesstransactionlogsinfo="accessTransactionLogs"
    ></accesstransactionlogscomponent>

       <accessdevicescomponent v-if="accessDeviceComponentTab"
      :isloading="isLoading"
       :accessdevicesinfo="accessDevices"
    ></accessdevicescomponent>
  </div>
</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";
import Tags from "@/components/Tags.vue";
import CommunicationProtocols from "@/components/CommunicationProtocols.vue";
import TagCategories from "@/components/TagCategories.vue";
import AccessPoints from "@/components/AccessPoints.vue";
import AccessPointGroups from "@/components/AccessPointGroups.vue";
import AccessTransactionLogs from "@/components/AccessTransactionLogs.vue";
import AccessDevices from "@/components/AccessDevices.vue";

export default {
  components: {
    tagscomponent: Tags,
    communicationprotocolscomponent: CommunicationProtocols,
    tagcategoriescomponent: TagCategories,
    accesspointscomponent: AccessPoints,
    accesspointgroupscomponent: AccessPointGroups,
    accesstransactionlogscomponent: AccessTransactionLogs,
    accessdevicescomponent: AccessDevices
  },
  created() {
    this.initialize();
    
  },
  data() {
    return {
      tagComponentTab: true,
      communicationProtocolComponentTab: false,
      tagCategoryComponentTab: false,
      accessPointComponentTab: false,
      accessPointGroupComponentTab: false,
      accessTransactionLogComponentTab: false,
      accessDeviceComponentTab: false,
      isLoading: true,
      tags: [],
      communicationProtocols: [],
      tagCategories: [],
      accessPoints: [],
      accessPointGroups: [],
      accessDevices: [],
      accessTransactionLogs: []
    };
  },
  watch: {
    dialog(val) {
      val || this.close();

  },
   search(value){
       const route= {
        search: this.$route.search
      }
       if ((this.search)){      
        route.query = {search: this.search}        
      }
      this.$router.push(route)      
    
    },
     '$route.query.search':{
      immediate: true,
      handler(value){
        this.search=value
      },
    }, 
  },
  
  computed: {}, 

  methods: {
    fetchTags(){
      this.isLoading=true
          Api()
          .get('/tags/getall')
          .then(response=>{
              this.tags=response.data,
              this.isLoading=false
          });
            this.$emit('tagsSaved')
      },
        fetchCommunicationProtocols(){
      this.isLoading=true
          Api()
          .get('/communicationProtocols/getall')
          .then(response=>{
              this.communicationProtocols=response.data,
              this.isLoading=false
          });
      },
        fetchTagCategories(){
      this.isLoading=true
          Api()
          .get('/tagCategories/getall')
          .then(response=>{
              this.tagCategories=response.data,
              this.isLoading=false
          });
      },
      fetchAccessPoints(){
      this.isLoading=true
          Api()
          .get('/accessPoints/getall')
          .then(response=>{
              this.accessPoints=response.data,
              this.isLoading=false
          });
      },
        fetchAccessPointGroups(){
      this.isLoading=true
          Api()
          .get('/accessPointGroups/getall')
          .then(response=>{
              this.accessPointGroups=response.data,
              this.isLoading=false
          });
      },
        fetchAccessTransactionLogs(){
      this.isLoading=true
          Api()
          .get('/accessTransactionLogs/getall')
          .then(response=>{
              this.accessTransactionLogs=response.data,
              this.isLoading=false
          });
      },
      fetchAccessDevices(){
      this.isLoading=true
          Api()
          .get('/accessDevices/getall')
          .then(response=>{
              this.accessDevices=response.data,
              this.isLoading=false
          });
      },
    initialize() {
      // this.fetchTags();
      // this.fetchCommunicationProtocols();
      // this.fetchTagCategories();
      // this.fetchAccessPoints();
      // this.fetchAccessPointGroups();
      // this.fetchAccessTransactionLogs();
      // this.fetchAccessDevices()
    },
  
     },
 
};
</script>
  